import api from '../token';

export const ListTurnoFechado = async () => {
  try {
    const response = await api.post('/getTurnoFechado');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

